import ProcessPanelLayout1 from "../Templates/Layout1";
import { closeOrthoVoxelTerrainDialog} from 'store/main/viewObjects';
import { useSelector} from 'react-redux';
import { RootState } from 'store';


function OrthoVoxelTerrain(props:any) {
    const {project, catalogId, name, file_type, source_type, isFolder} = props;

    const viewObject = useSelector((state: RootState) => state.main.viewObject);
    const {ovtstate:open } = viewObject;

    return (
		<ProcessPanelLayout1 project={project} catalogId={catalogId} name={name} file_type={file_type} source_type={source_type} closeDialog={closeOrthoVoxelTerrainDialog} state={open} isFolder={isFolder}/>
  	)
}

export default OrthoVoxelTerrain